import {gql} from '@apollo/client'

export const loggedIn = gql`
query {
  loggedIn
}
`

